import { Enums } from '../models/common/enums'

export class OperatorComponent {
	public static GetBaseSettings(): Enums.SimaxOperatorSetting[] {
		//Kolejność ma znaczenie przy pobieraniu
		return [
			Enums.SimaxOperatorSetting.LoggedOperator,//Pobranie zalogowanego operatora
			Enums.SimaxOperatorSetting.DictionaryVersion, //Pobranie wersji słowników
			Enums.SimaxOperatorSetting.ActiveViews, //Pobranie aktywnych widoków
			Enums.SimaxOperatorSetting.DataTypeFormatGroup, //Pobranie formatów data typów
			Enums.SimaxOperatorSetting.DateFormatLong, //Pobranie dlugiego formatu daty
			Enums.SimaxOperatorSetting.DateFormatShort, //Pobranie krotkiego formatu daty
			Enums.SimaxOperatorSetting.DistributorHierarchyEnabled, //Pobranie informacji o dostepnosci hierarchi dystrybutorow
			Enums.SimaxOperatorSetting.Logo, //Pobranie logo
			Enums.SimaxOperatorSetting.MapZoomDefaultGoogle, //Pobranie domyslnego poziomu zoom'a google
			Enums.SimaxOperatorSetting.PageItemsNumber, //Pobranie dostepnych do wyboru ilosci wierszy w pagerze
			Enums.SimaxOperatorSetting.MarkerCustomFormatStringDevice, //Pobranie dedykowanego formatu tekstu na markerze dla urzadzen
			Enums.SimaxOperatorSetting.MarkerCustomFormatStringMeter, //Pobranie dedykowanego formatu tekstu na markerze dla meterow
			Enums.SimaxOperatorSetting.MarkerCustomFormatStringLocation, //Pobranie dedykowanego formatu tekstu na markerze dla lokalizacji
			Enums.SimaxOperatorSetting.MarkerCustomFormatStringTask, //Pobranie dedykowanego formatu tekstu na markerze dla zadań
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringDevice, //Pobranie dedykowanego formatu tekstu obiektu dla urzadzenia
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringDistributor, //Pobranie dedykowanego formatu tekstu obiektu dla dystrybutora
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringIssue, //Pobranie dedykowanego formatu tekstu obiektu dla zgloszenia
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringLocation, //Pobranie dedykowanego formatu tekstu obiektu dla lokalizacji
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringMeter, //Pobranie dedykowanego formatu tekstu obiektu dla metera
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringOperator, //Pobranie dedykowanego formatu tekstu obiektu dla operatora
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringReport, //Pobranie dedykowanego formatu tekstu obiektu dla raportu
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringRoute, //Pobranie dedykowanego formatu tekstu obiektu dla trasy
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringSimCard, //Pobranie dedykowanego formatu tekstu obiektu dla karty sim
			Enums.SimaxOperatorSetting.ObjectCustomFormatStringTask, //Pobranie dedykowanego formatu tekstu obiektu dla zlecenia
			Enums.SimaxOperatorSetting.TaskStatusFlow, //Pobieranie flow dla zadań
			Enums.SimaxOperatorSetting.PackageStatusFlow, //Pobieranie flow dla paczek
			Enums.SimaxOperatorSetting.OrderStatusFlow, //Pobieranie flow dla zamowien
			Enums.SimaxOperatorSetting.IssueStatusFlow, //Pobieranie flow dla zgłoszeń
			Enums.SimaxOperatorSetting.ImportPlugin, //Pobranie pluginów do importu
			Enums.SimaxOperatorSetting.ExportPlugin, //Pobranie pluginów do exportu
			Enums.SimaxOperatorSetting.MarkerColor, //markers color, for map legend
			Enums.SimaxOperatorSetting.MxGraphDictionaryRule,
			Enums.SimaxOperatorSetting.MapProvider, // Pobieranie dostawcy map z ustawien operatora
			Enums.SimaxOperatorSetting.DictionaryCompleteness,
			Enums.SimaxOperatorSetting.PasswordPolicyRules,
		]
	}
}
